export default __webpack_public_path__ + "static/media/ic-cn.6b363a84.svg";